import { useState } from 'react';
import logo from 'assets/Talo-Logo-White.webp';
import Button from 'components/buttons/Button';
import LegitScriptSeal from 'components/core/legitscript-seal';
import DavePhoto from 'assets/profile-photos/Dave.webp';
import GavPhoto from 'assets/profile-photos/Gav.webp';
import InvestorPhoto from 'assets/profile-photos/Investor.webp';
import RickyPhoto from 'assets/profile-photos/Ricky.webp';
import { ROUTES } from 'config/route-configuration';

const experts = [
  { name: 'Dave', image: DavePhoto },
  { name: 'Gav', image: GavPhoto },
  { name: 'Ricky', image: RickyPhoto },
  { name: 'Investor', image: InvestorPhoto },
];

const Footer = () => {
  const [copied, setCopied] = useState(false);
  const supportEmail = 'support@jointalo.com';

  const handleCopyEmail = async () => {
    try {
      await navigator.clipboard.writeText(supportEmail);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy support email', error);
    }
  };

  return (
    <footer className="w-full bg-[#1A3736] px-6 pb-10 pt-10 text-white rounded-t-3xl">
      {/* Start top part */}
      <div className="mx-auto w-full overflow-hidden bg-[#1A3736]">
        <div className="flex flex-col items-center justify-center gap-6 px-4 pb-10 pt-6 text-center">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#F6A59C]">
            <svg viewBox="0 0 24 24" className="h-6 w-6 text-[#1A3736]" aria-hidden="true">
              <path
                d="M12 2a9 9 0 0 0-5.84 15.82L4.5 22l4.44-1.86A9 9 0 1 0 12 2Z"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinejoin="round"
              />
              <path
                d="M9.75 9.5a2.25 2.25 0 1 1 3.4 2 2.1 2.1 0 0 0-1.15 1.95v.35"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.6"
                strokeLinecap="round"
              />
              <circle cx="12" cy="17.25" r="0.9" fill="currentColor" />
            </svg>
          </div>
          <h2 className="font-mont text-[30px] font-black leading-tight text-white">Need Help?</h2>
          <p className="max-w-2xl text-base text-white/80">
            Our team is here to help with any questions about your order, subscription or treatment.
          </p>
          <Button text="Contact support" link="mailto:support@jointalo.com" variant="secondary" />
          <div className="text-xs text-white/70">
            <span>Can’t open your email app? Copy our email or use webmail.</span>
            <div className="mt-1 flex flex-wrap items-center justify-center gap-2 text-white/60">
              <button type="button" onClick={handleCopyEmail} className="hover:text-white">
                {copied ? 'Copied!' : 'Copy email'}
              </button>
              <span aria-hidden="true">·</span>
              <a
                href={`https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}`}
                className="hover:text-white"
                target="_blank"
                rel="noreferrer"
              >
                Open Gmail
              </a>
              <span aria-hidden="true">·</span>
              <a
                href={`https://outlook.office.com/mail/deeplink/compose?to=${supportEmail}`}
                className="hover:text-white"
                target="_blank"
                rel="noreferrer"
              >
                Open Outlook
              </a>
            </div>
          </div>
          <div className="flex flex-wrap items-center justify-center gap-0">
            {experts.map((expert) => (
              <div
                key={expert.name}
                className="-ml-3 h-14 w-14 overflow-hidden rounded-full border-2 border-[#E4E7E4] bg-[#2C4A49] first:ml-0"
              >
                <img
                  src={expert.image}
                  alt={expert.name}
                  className={`h-full w-full object-cover ${
                    expert.name === 'Dave' || expert.name === 'Gav' ? '-translate-x-1' : ''
                  }`}
                />
              </div>
            ))}
          </div>
        </div>
        {/* End top part */}
        {/* Start Bottom part */}
        <div className="flex flex-col gap-6 border-t border-white/10 pt-8 md:flex-row md:gap-12">
          <div className="md:w-1/4 space-y-3">
            <img src={logo} alt="Talo logo" className="h-10 w-auto" />
            <p className="text-sm text-white/70">&copy; {new Date().getFullYear()} Talo. All rights reserved.</p>
            <LegitScriptSeal className="inline-block" />
          </div>
          <div className="md:w-1/4 space-y-2">
            <p className="text-sm font-semibold text-white">Treatment</p>
            <a href="#" className="block text-sm text-white/80 hover:text-white">
              Get started
            </a>
            <a href="#" className="block text-sm text-white/80 hover:text-white">
              ED treatment
            </a>
          </div>
          <div className="md:w-1/4 space-y-2">
            <p className="text-sm font-semibold text-white">Support</p>
            <a href="mailto:support@jointalo.com" className="block text-sm text-white/80 hover:text-white underline">
              support@jointalo.com
            </a>
            <a href={ROUTES.TERMSOFUSE} className="block text-sm text-white/80 hover:text-white">
              Terms of Use
            </a>
            <a href={ROUTES.TERMSOFSUPPLY} className="block text-sm text-white/80 hover:text-white">
              Terms of Supply
            </a>
            <a href={ROUTES.PRIVACYPOLICY} className="block text-sm text-white/80 hover:text-white">
              Privacy policy
            </a>
          </div>
          <div className="md:w-1/4" />
        </div>
        {/* End Bottom part */}
      </div>
    </footer>
  );
};

export default Footer;
